var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        "append-to-body": "",
        title: "已有类似商品",
        visible: _vm.centerDialogVisible,
        width: "80%",
        center: "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.centerDialogVisible = $event
        },
      },
    },
    [
      _c("staticTable", {
        attrs: {
          tableData: _vm.tableData,
          loading: _vm.loading,
          operationWidth: 150,
          isOperation: false,
        },
        on: { upLoading: _vm.upLoading, close: _vm.close },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }